'use client';

import { twMerge } from '@shared/themes';
import { ROUTES } from '@shared/utils';
import { useTranslations } from 'next-intl';
import { PageHeader } from '../../../PageHeader/PageHeader';
import { usePurchaseDetails } from '../context/PurchaseDetailsContext';

type PurchaseDetailsHeaderProps = {
  className?: string;
};

/**
 * Renders the page header with the purchased lottery name.
 * Reads its data from `PurchaseDetailsProvider`, so it must be rendered inside it.
 */
function PurchaseDetailsHeader({ className }: PurchaseDetailsHeaderProps) {
  const t = useTranslations('lotteries');
  const { lotteryName } = usePurchaseDetails();

  return <PageHeader title={t(`${lotteryName}.name`)} variant="subheader" className={twMerge('ll-container-inner', className)} fallbackUrl={ROUTES.LOTTO.PURCHASES} />;
}

export { PurchaseDetailsHeader, type PurchaseDetailsHeaderProps };
